import { action, observable, makeObservable, computed } from 'mobx'
import { Nullable } from 'types/definitions'
import DocumentType from 'documents/DocumentType'

export class DocumentCreationItemViewModel {
  @observable file: File
  @observable types: Nullable<DocumentType[]> = null
  @observable selectedType: Nullable<DocumentType> = null
  @observable typeName: string = 'Select type'
  @observable searchQuery: string = ''
  @observable isDropdownOpen: boolean = false

  constructor(
    file: File,
    documentTypes: DocumentType[],
    private incrementTypeSelected: () => void,
  ) {
    makeObservable(this)
    this.file = file
    this.types = documentTypes
  }

  @computed
  get isPlaceholder() {
    return this.selectedType === null && this.typeName === 'Select type'
  }

  @computed
  get filteredTypes(): DocumentType[] {
    if (!this.types) return []
    const sorted = [...this.types].sort((a, b) => a.name.localeCompare(b.name))
    if (!this.searchQuery.trim()) return sorted
    const query = this.searchQuery.toLowerCase().trim()
    return sorted.filter((type) => type.name.toLowerCase().includes(query))
  }

  @action
  setSearchQuery(query: string) {
    this.searchQuery = query
  }

  @action
  clearSearchQuery() {
    this.searchQuery = ''
  }

  @action
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  @action
  closeDropdown() {
    this.isDropdownOpen = false
    this.searchQuery = ''
  }

  @action
  setDocumentType(type: DocumentType | null) {
    if (this.typeName === 'Select type') {
      this.incrementTypeSelected()
    }

    if (!type) {
      this.typeName = 'Other documents'
    } else {
      this.typeName = type.name
    }

    this.selectedType = type
  }
}
